<template>
  <div>
    <v-row dense>

      <v-col cols="12" md="3" v-if="!refinanceFlag">
        <comdatey :label="$t('labels.ClosingDateR')" v-model="pro.ClosingDate" :max="date2Years" />
      </v-col>

      <template v-if="refinanceFlag">
        <v-col cols="12" md="3">
          <comdatey :label="$t('labels.OriginalPurchaseDate')" v-model="pro.PurchaseDate" :max="dateNow" />
        </v-col>

        <v-col cols="12" md="3">
          <p_money :label="$t('labels.EstimatedPropertyValue')" v-model="pro.EstimatedValue" />
        </v-col>
        <v-col cols="12" md="3">
          <p_money :label="$t('labels.OriginalPurchasePrice')" v-model="pro.OriginalValue" />
        </v-col>
      </template>



      <v-col cols="12" md="3">
        <p_dd menu="DwellingType" v-model="app.InterView.PropertyTypeDD" :label="$t('labels.PropertyType')" />
      </v-col>

      
      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="DwellingStyle" v-model="pro.DwellingStyleDD" :label="$t('labels.PropertyStyle')" />
      </v-col>
      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="NewConstruction" v-model="pro.NewConstructionDD" :label="$t('labels.ConstructionType')" />
      </v-col>
      <v-col cols="12" md="3" v-if="pro.NewConstructionDD == 0">
        <v-text-field min="1" max="999" type="number"  v-model="pro.Age"  @change="preventOverflow" :label="$t('labels.Age')" />
      </v-col>
      <v-col cols="12" md="3" v-if="pro.PropertyTypeDD == 2">
        <v-text-field v-money type="number" v-model="pro.CondoFees" prefix="$">
          <template slot="label"><span v-html="$t('labels.MonthlyCondoFees')"/></template>
        </v-text-field>
      </v-col>
      <v-col v-if="app.showMortgage == true" cols="12" md="3">
          <p_money v-model="pro.AnnualTaxes" :label="$t('labels.AnnualTaxes')" />
 
      </v-col>
      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <v-text-field type="number" v-model="pro.TaxYear">
          <template slot="label"><span v-html="$t('labels.TaxationYear')"/></template>
        </v-text-field>
      </v-col>

      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="PropertyType" v-model="pro.PropertyTypeDD" :label="$t('labels.Tenure')" />
      </v-col>

      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="HeatType" v-model="pro.HeatTypeDD" :label="$t('labels.HeatType')" />
      </v-col>

      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="WaterType" v-model="pro.WaterTypeDD" :label="$t('labels.WaterType')" />
      </v-col>

      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <p_dd menu="SewageType" v-model="pro.SewageTypeDD" :label="$t('labels.SewageType')" />
      </v-col>

      <v-col v-if="app.showMortgage == true" cols="12" md="3">
        <v-text-field type="number" v-model="pro.LivingSpace">
          <template slot="label"><span v-html="$t('labels.LivingSpace')"/></template>
        </v-text-field>
      </v-col>

      <v-col cols="12" md="3" v-if="pro.PropertyTypeDD != 2 && app.showMortgage == true">
        <v-text-field type="number" v-model="pro.LotSize">
          <template slot="label"><span v-html="$t('labels.LotSize')"/></template>
        </v-text-field>
      </v-col>
 
      <v-col v-if="app.showMortgage == true"  cols="12" md="3">
        <p_dd menu="GarageSize" v-model="pro.GarageSizeDD" :label="$t('labels.GarageSize')" />
      </v-col>
      <v-col cols="12" md="3" v-if="pro.GarageSizeDD >= 1 && pro.GarageSizeDD <= 3">
        <p_dd menu="GarageType" v-model="pro.GarageTypeDD" :label="$t('labels.GarageType')" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import p_dd from "@/shared/components/ddSelect";
import comdatey from "@/shared/components/datePickerY";
import p_money from "@/shared/components/money";
export default {
  components: {
    p_dd,
    comdatey,p_money
  },
  props: ["frm","refinanceFlag","app"],
  data() {
    return {         
      pro: this.frm.SubjectProperty,
    };
  },  
  computed:{
    dateNow(){
      let n = new Date();     
      return n.toISOString().substr(0, 10);
    },
     date2Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() + 2);
      return n.toISOString().substr(0, 10);
    }
  },
  methods:{
    preventOverflow(){
       if (parseInt(this.pro.Age) > 999) {
    this.pro.Age = 999;
  }
    if (parseInt(this.pro.Age) < 1) {
    this.pro.Age = 1;
  }
    }
  }
};
</script>
